<div
  class="aker-page"
  [class.has-chat-history]="chatHistory.length"
  [class.is-sidebar-collapsed]="isChatSidebarCollapsed"
>
  <aside
    *ngIf="chatHistory.length"
    class="aker-chat-sidebar"
    aria-label="Chats recientes"
  >
    <div class="aker-sidebar-actions">
      <button
        type="button"
        class="aker-sidebar-toggle"
        [attr.aria-expanded]="!isChatSidebarCollapsed"
        aria-label="Mostrar u ocultar historico de chats"
        (click)="toggleChatSidebar()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <button type="button" class="aker-new-chat" (click)="startNewChat()">
        <i class="pe-7s-plus"></i>
        <span>Nuevo chat</span>
      </button>
    </div>

    <div class="aker-chat-history">
      <p class="aker-chat-history-title">Recientes</p>
      <div
        *ngFor="let chat of chatHistory; trackBy: trackByChat"
        class="aker-chat-history-row"
        [class.is-active]="chat.id === currentChatId"
      >
        <button
          type="button"
          class="aker-chat-history-item"
          [disabled]="isSending"
          (click)="selectChat(chat)"
        >
          <i class="pe-7s-comment"></i>
          <span>{{ chat.title }}</span>
        </button>

        <button
          type="button"
          class="aker-chat-options"
          aria-label="Opciones del chat"
          [disabled]="isSending || deletingChatId === chat.id"
          (click)="toggleChatMenu(chat, $event)"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </aside>

  <section class="aker-chat-panel">
    <div
      class="aker-shell"
      [class.is-centered]="!hasMessages && !isLoadingChatMessages"
      [class.has-messages]="hasMessages || isLoadingChatMessages"
    >
      <div *ngIf="!hasMessages && !isLoadingChatMessages" class="aker-hero">
        <p class="aker-eyebrow">
          Hola<span *ngIf="userName">, {{ userName }}</span>
        </p>
        <h1>{{ heroTitle }}</h1>
        <p *ngIf="assistantStatus" class="aker-status">{{ assistantStatus }}</p>
      </div>

      <div #chatMessages class="aker-messages">
        <article *ngIf="isLoadingChatMessages" class="aker-bubble is-assistant">
          <span class="aker-badge">
            <span>AKER</span>
          </span>
          <div class="aker-thinking">
            <span class="aker-thinking-text">Cargando conversacion...</span>
          </div>
        </article>

        <article
          *ngFor="let message of messages; trackBy: trackByMessage"
          class="aker-bubble"
          [ngClass]="{
            'is-user': message.role === 'user',
            'is-assistant': message.role === 'assistant',
            'is-error': message.isError
          }"
        >
          <span class="aker-badge">
            <span>{{ message.role === 'user' ? 'Tu' : 'AKER' }}</span>
            <span
              *ngIf="message.role === 'assistant' && message.isStreaming"
              class="aker-wait-time"
            >
              {{ formatElapsedTime(message.elapsedSeconds) }}
            </span>
          </span>
          <div
            *ngIf="message.content"
            class="aker-content"
            [innerHTML]="getMessageHtml(message.content)"
          ></div>
          <div *ngIf="message.attachments?.length" class="aker-attachments">
            <a
              *ngFor="let attachment of message.attachments"
              class="aker-attachment"
              [href]="attachment.url"
              [download]="attachment.name"
            >
              <i class="pe-7s-file"></i>
              <span>{{ attachment.name }}</span>
            </a>
          </div>
          <div
            *ngIf="message.isStreaming && !message.content"
            class="aker-thinking"
          >
            <span class="aker-thinking-text">Pensando...</span>
          </div>
          <div
            *ngIf="
              message.role === 'assistant' &&
              !message.isStreaming &&
              message.thoughtSeconds !== undefined
            "
            class="aker-thought-duration"
          >
            Penso durante {{ formatElapsedTime(message.thoughtSeconds) }}
          </div>
        </article>
      </div>

      <div class="aker-composer">
        <label class="sr-only" for="aker-input">Mensaje</label>
        <textarea
          #chatTextarea
          id="aker-input"
          [(ngModel)]="prompt"
          [disabled]="isComposerLocked"
          rows="1"
          placeholder="Pregunta lo que quieras"
          (keydown)="onPromptKeydown($event)"
          (input)="onPromptInput()"
        ></textarea>

        <div class="aker-toolbar">
          <button
            *ngIf="isSending"
            type="button"
            class="aker-cancel"
            aria-label="Detener respuesta"
            (click)="cancelActiveRequest()"
          >
            <i class="pe-7s-close"></i>
          </button>
          <button
            type="button"
            class="aker-send"
            aria-label="Enviar mensaje"
            [disabled]="isComposerLocked || !prompt.trim()"
            (click)="sendMessage()"
          >
            <i class="pe-7s-paper-plane"></i>
          </button>
        </div>
      </div>

      <div *ngIf="!hasMessages" class="aker-suggestions">
        <button
          *ngFor="let suggestion of visibleSuggestions"
          type="button"
          class="aker-chip"
          [disabled]="isComposerLocked"
          (click)="useSuggestion(suggestion)"
        >
          {{ suggestion }}
        </button>
      </div>
    </div>
  </section>

  <div
    *ngIf="openedChatMenuId"
    class="aker-chat-menu"
    [style.top.px]="openedChatMenuTop"
    [style.left.px]="openedChatMenuLeft"
  >
    <button type="button" (click)="deleteChat(getOpenedChatMenu(), $event)">
      Eliminar
    </button>
  </div>
</div>
